"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var _react = require("@emotion/react");
var _token = require("@jarvis/token");
var _react1 = _interopRequireWildcard(require("react"));
var _typographyThemes = require("./Typography.themes");
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n            ",
        "\n            margin: 0;\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var FontWeightValue = function(fontWeight) {
    switch(fontWeight){
        case "light":
            return _token.FONT_WEIGHT_LIGHT;
        case "regular":
            return _token.FONT_WEIGHT_REGULAR;
        case "semibold":
            return _token.FONT_WEIGHT_SEMIBOLD;
        case "bold":
            return _token.FONT_WEIGHT_BOLD;
        case "black":
            return _token.FONT_WEIGHT_BLACK;
        default:
            return _token.FONT_WEIGHT_REGULAR;
    }
};
var Typography = /*#__PURE__*/ (0, _react1).forwardRef(function(_param, ref) {
    var colorVariant = _param.colorVariant, component = _param.component, display = _param.display, _fontWeight = _param.fontWeight, fontWeight = _fontWeight === void 0 ? "regular" : _fontWeight, _variant = _param.variant, variant = _variant === void 0 ? "body1" : _variant, as = _param.as, props = _objectWithoutProperties(_param, [
        "colorVariant",
        "component",
        "display",
        "fontWeight",
        "variant",
        "as"
    ]);
    var Element = as !== null && as !== void 0 ? as : _typographyThemes.TypographyTagVariant[variant];
    var fontWeightValue = FontWeightValue(fontWeight);
    var styles = _objectSpread({}, _typographyThemes.TypographyStylesByVariant[variant], colorVariant ? {
        color: colorVariant
    } : undefined, {
        display: display
    });
    return /*#__PURE__*/ (0, _jsxRuntime).jsx(Element, _objectSpread({
        css: [
            (0, _react).css(_templateObject(), styles),
            fontWeightValue && "font-weight: ".concat(fontWeightValue), 
        ],
        ref: ref
    }, props));
});
var _default = /*#__PURE__*/ (0, _react1).memo(Typography);
exports.default = _default;
